import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { GetCrmProjectByIdProps } from ".";

export function useGetCrmProjectById({ crmProjectId }: GetCrmProjectByIdProps) {
    return useQuery({
        ...queryKeys.crm_project.byId(crmProjectId!),
        enabled: !!crmProjectId,
    });
}